import { useGenericDocumentService } from "serviceHooks";

function useGenericDocumentDownload(documentId: number) {
  const genericDocumentService = useGenericDocumentService();
  const onDownloadClick = () => {
    return genericDocumentService.download(documentId);
  };

  return onDownloadClick;
}

export default useGenericDocumentDownload;
